import SubmissionError from '../../../error/SubmissionError';
import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  INVOICETAXTYPE_CREATE_ERROR,
  INVOICETAXTYPE_CREATE_LOADING,
  INVOICETAXTYPE_CREATE_SUCCESS,
  INVOICETAXTYPE_CREATE_VIOLATIONS,
  INVOICETAXTYPE_CREATE_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  created: null,
  violations: {}
};

function error(error) {
  return {type: INVOICETAXTYPE_CREATE_ERROR, error};
}

function loading(loading) {
  return {type: INVOICETAXTYPE_CREATE_LOADING, loading};
}

function success(created) {
  return {type: INVOICETAXTYPE_CREATE_SUCCESS, created};
}

function violations(violations) {
  return {type: INVOICETAXTYPE_CREATE_VIOLATIONS, violations};
}

function reset() {
  return {type: INVOICETAXTYPE_CREATE_RESET};
}

const getters = {
  created: state => state.created,
  error: state => state.error,
  loading: state => state.loading,
  violations: state => state.violations,
};

const actions = {
  create({ commit }, values) {
    commit(loading(true));
    commit(violations({}));
    commit(error(null));
    values.tax = parseFloat(values.tax);
    return http.fetch('/invoice_tax_types', {method: 'POST', body: JSON.stringify(values)})
      .then(response => {
        commit(loading(false));

        return response.json();
      })
      .then(data => {
        commit(success(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors));
          return;
        }
        commit(error(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [INVOICETAXTYPE_CREATE_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [INVOICETAXTYPE_CREATE_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [INVOICETAXTYPE_CREATE_SUCCESS] (state, payload) {
      state.created = payload.created;
    },
    [INVOICETAXTYPE_CREATE_VIOLATIONS] (state, payload) {
      state.violations = payload.violations;
    },
    [INVOICETAXTYPE_CREATE_RESET] (state) {
      state.loading = false;
      state.error = '';
      state.created = null;
      state.violations = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/invoicetaxtype/create.js